module.exports = __webpack_public_path__ + "img/20200608_143324.e44254b4.jpg";